import { Button } from "@common/components/ui/button"
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@common/components/ui/card"
import type { ErrorComponentProps } from "@tanstack/react-router"
import { RotateCw } from "lucide-react"

const RouteError = ({ error }: ErrorComponentProps) => {
  const message =
    error instanceof Error ? error.message : "An unexpected error occurred"

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="flex flex-col items-center max-w-sm w-full gap-10">
        <img
          src="/assets/images/fleetcraft-logo-indigo.svg"
          alt="Fleetcraft"
          className="h-auto w-auto max-h-8"
        />
        <Card className="w-full">
          <CardHeader className="text-center">
            <CardTitle>Something went wrong</CardTitle>
            <CardDescription>{message}</CardDescription>
          </CardHeader>
          <CardFooter className="justify-center">
            <Button onClick={() => window.location.reload()}>
              <RotateCw />
              Reload
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  )
}

export default RouteError
